import React, { Component } from "react";
import { Trans, t } from "@lingui/macro";
import { I18n } from "@lingui/react";
import { I18n as I18nProp } from "@lingui/core";
import {
  AnalyticsTrends,
  spacing,
  palette,
  borderRadius,
} from "@conserveit/blocks";
import styled from "styled-components";

const Container = styled.div`
  max-width: 120px;
  text-align: right;
  margin-bottom: ${spacing.default};
`;

const Button = styled.button`
  color: ${palette.red5};
`;

const ImageContainer = styled.a.attrs({ target: "_blank" })`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  border: 1px solid ${palette.neutral5};
  border-radius: ${borderRadius.default};
`;

const Img = styled.img`
  object-fit: cover;
  /* Fallbacks - does not affect behaviour of object-fit */
  max-width: 100%;
  max-height: 100%;
`;

interface Props {
  onRemove: (() => void) | null;
  src: string;
  alt: string;
}

interface State {
  nonImageAttachment: boolean;
}
export class ImagePreview extends Component<Props, State> {
  private preview: React.RefObject<HTMLImageElement>;

  static defaultProps = {
    onRemove: null,
    alt: "Image preview",
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      nonImageAttachment: false,
    };

    this.preview = React.createRef();
  }

  setIsNonImage = () => {
    // If the attachment src doesn't resolve to an image, assume it's a different file type
    this.setState({
      nonImageAttachment: true,
    });
  };

  handleRemove = (i18n: I18nProp) => () => {
    if (
      window.confirm(
        i18n._(
          t(
            "action_form.confirm_remove_attachment"
          )`You are about to remove the attachment from this action, continue?`
        )
      )
    ) {
      this.props.onRemove?.();
    }
  };

  render() {
    const { src, alt } = this.props;

    return (
      <I18n>
        {({ i18n }) => (
          <Container>
            <ImageContainer href={src}>
              {this.state.nonImageAttachment ? (
                <AnalyticsTrends />
              ) : (
                <Img
                  ref={this.preview}
                  onError={this.setIsNonImage}
                  src={src}
                  alt={alt}
                />
              )}
            </ImageContainer>

            {this.props.onRemove && (
              <Button onClick={this.handleRemove(i18n)}>
                <Trans id="action_form.remove">Remove</Trans>
              </Button>
            )}
          </Container>
        )}
      </I18n>
    );
  }
}
